import React, { Component } from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";
import Modal from "../components/modal";
import PricingForm from "../components/pricingform";
import Gallery from "../components/gallery";
import SEO from "../components/seo";

class PricingTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      gallery: false
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
    if (!this.state.modal) {
      document.querySelector("#site").classList.add("is-clipped");
    } else {
      document.querySelector("#site").classList.remove("is-clipped");
    }
  }

  render() {
    const page = this.props.data.wordpressPage;
    const excerpt = page.acf.text.replace(/<\/?[^>]+(>|$)/g, "");
    const pricingFile = page.acf.pricing ? (
      <a
        href={page.acf.pricing.localFile.publicURL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Click here to view detailed pricing information.
      </a>
    ) : (
      ""
    );
    return (
      <Layout location="pricing">
        <SEO title={page.title} description={excerpt} />
        <section className="section">
          <div className="container">
            <div className="columns">
              <div className="column is-6">
                <h1 dangerouslySetInnerHTML={{ __html: page.title }} />
                <div dangerouslySetInnerHTML={{ __html: page.acf.text }} />
                {pricingFile}
                <button
                  onClick={() => this.toggleModal()}
                  className="button is-primary is-large"
                >
                  Book Now
                </button>
              </div>
              <div className="column is-6">
                <Img
                  sizes={page.acf.side_image.localFile.childImageSharp.sizes}
                  alt={page.title}
                />
              </div>
            </div>
            <Gallery
              items={page.acf.gallery}
              column="3"
              close={this.toggleModal}
            />
          </div>
        </section>
        <Modal showing={this.state.modal} close={this.toggleModal}>
          <PricingForm buttonText="Submit" package={page.title} />
        </Modal>
      </Layout>
    );
  }
}

export default PricingTemplate;

export const query = graphql`
  query PricingQuery($id: Int!) {
    wordpressPage(wordpress_id: { eq: $id }) {
      title
      acf {
        text
        pricing {
          localFile {
            publicURL
          }
        }
        side_image {
          localFile {
            childImageSharp {
              sizes(maxWidth: 800) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
        gallery {
          alt_text
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
      }
    }
  }
`;
